import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import { hideError } from '../actions/LayoutActions';
import { RouteComponentProps } from 'react-router';
import DefaultLayout from '../components/DefaultLayout';
import { ReactNode } from 'react';


const mapStateToProps = (state: RootState) => ({
    showError: state.layoutRdc.showError,
    errorMessage: state.layoutRdc.errorMessage,
    isAuthenticated: state.authRdc.isAuthenticated,
    isPublic: true
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        hideError: () => {
            dispatch(hideError())
        }
    })
}

export type LoggedInLayoutProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any> & { children: ReactNode }

const PublicLayoutCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(DefaultLayout);

export default PublicLayoutCnn